import AchievementsCarousel from '../../../../utils/AchievementsCarousel';
import HomeStakesAnimation from '../../../../utils/HomeStakesAnimation';

export default class HomePageInit {
    static init() {
        AchievementsCarousel.init();
        HomeStakesAnimation.init();
        //        EventPopIn.init();
    }
}
